import { combineReducers } from 'redux'
import dashboard from './dashboard';
import terminal from './terminal';
import pcspec from './pcspec';
import installedinfosearch from './installedinfosearch';
import adapter from './adapter';
import installedapp from './installedapp';
import runningapp from './runningapp';
import setting from './setting';
import ossetting from './ossetting';
import user from './user';
import version from './version';
import login from './login';
import account from './account';
import workhistory from './workhistory';
import workhistorystatus from './workhistorystatus';
import attendstatus from './attendstatus';
import filter from './filter';
import aiassistant from './aiassistant';
import ActionTypes from "../constants/ActionTypes";

const appReducer = combineReducers({
  dashboard,
  terminal,
  pcspec,
  installedinfosearch,
  adapter,
  installedapp,
  runningapp,
  setting,
  ossetting,
  user,
  version,
  login,
  account,
  workhistory,
  workhistorystatus,
  attendstatus,
  filter,
  aiassistant
});

const rootReducer = (state, action) => {
  if (action.type === ActionTypes.LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};


export default rootReducer;
